const Card = (props) => {

    const { name, pic_url, description, price } = props.data

    return (
        <div className="card" 
        // style={{backgroundImage: `url(${pic_url})`}}
        >
            <div className="cardImg" style={{backgroundImage: `url(${pic_url})`}}></div>
            <div className="cardDetails">
            <span className="cardTitle josefin-light">{name}</span>
            <span className="cardDescription">{description}</span>
            <div className="cardFooter">
                {/* <button className="cardButton addItem">{"+"}</button> */}
                <span className="cardPrice josefin-light">₹ {price}</span>
            </div>
            </div>
        </div>
    )
}

export default Card